import { render, staticRenderFns } from "./center_1.vue?vue&type=template&id=5efd33dc&scoped=true&"
import script from "./center_1.vue?vue&type=script&lang=js&"
export * from "./center_1.vue?vue&type=script&lang=js&"
import style0 from "./center_1.vue?vue&type=style&index=0&id=5efd33dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efd33dc",
  null
  
)

export default component.exports